import { Component } from '@angular/core';

/**
 * Rendered for any URL the router does not recognise.
 *
 * There was no wildcard route at all, so a typo or a stale link produced the app
 * chrome above a completely empty page with nothing to say what had happened.
 *
 * Deliberately not behind AdminGuard, matching access-denied: someone who is not
 * an admin should still be told the address is wrong rather than bounced.
 */
@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html'
})
export class NotFoundComponent {}
